import { Loader2 } from "lucide-react";

type EventDataLoadingProps = {
  /** Shown under the spinner */
  message?: string;
  className?: string;
};

/**
 * Full-page loading state while fetching data for the active planner event
 * (avoids showing stale content during event switches).
 */
export function EventDataLoading({
  message = "Učitavanje podataka za izabrani događaj...",
  className,
}: EventDataLoadingProps) {
  return (
    <div
      className={
        className ??
        "min-h-screen flex flex-col items-center justify-center gap-8 px-3 py-4 bg-gradient-to-br from-background to-muted"
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 className="h-10 w-10 animate-spin text-primary" aria-hidden />
      <p className="text-center text-muted-foreground text-sm sm:text-base max-w-md px-2">
        {message}
      </p>
      <div className="w-full max-w-lg space-y-3 px-3">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-12 rounded-lg bg-muted animate-pulse"
          />
        ))}
      </div>
    </div>
  );
}

type OverviewStatsGridSkeletonProps = {
  /** Number of stat cells (e.g. 4 for gosti/budžet, 3 for zadaci) */
  cells?: number;
  showInlineLabel?: boolean;
};

/**
 * Compact skeleton for profil overview cards / accordions while overview data loads.
 */
export function OverviewStatsGridSkeleton({
  cells = 4,
  showInlineLabel = true,
}: OverviewStatsGridSkeletonProps) {
  return (
    <div className="space-y-3 py-0.5">
      {showInlineLabel && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin shrink-0" aria-hidden />
          <span>Učitavanje podataka...</span>
        </div>
      )}
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: cells }).map((_, i) => (
          <div key={i} className="space-y-2">
            <div className="h-8 w-20 max-w-full rounded-md bg-muted animate-pulse" />
            <div className="h-3 w-28 max-w-full rounded bg-muted/80 animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
}
